import '../../../../assets/css/ReviewPopup.css'; 
import RatingStars from "../../../../components/RatingStars";
import {format } from 'date-fns';

const ReviewPopup = ({ review, onClose }) => {
    if (!review) return null;

    return (
        <div className="review-popup">
            <div className="new-popup-content">
                <button className="close-popup" onClick={onClose}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" d="m3.426 2.024.094.083L8 6.586l4.48-4.479a1 1 0 0 1 1.497 1.32l-.083.095L9.414 8l4.48 4.478a1 1 0 0 1-1.32 1.498l-.094-.083L8 9.413l-4.48 4.48a1 1 0 0 1-1.497-1.32l.083-.095L6.585 8 2.106 3.522a1 1 0 0 1 1.32-1.498Z"></path></svg></button>
                <div className="review-popup-header">
                    <div className="new-reviews-profile">
                        {review.image ? (
                            <img src={review.image} alt="Review" />
                        ) : (
                            <div className="fallback-avatar">
                                {review.name.charAt(0)}
                            </div>
                        )}
                    </div>
                    <div className='google_review-popup-title'>{review.name} <div className='popup_google_DateTime__Time'>{review.review_date ? format(new Date(review.review_date), 'yyyy-MM-dd') : ''}</div></div>
                </div>
                <div className='google_review_popup_rating'><RatingStars average_rating={review.rating} /></div>
                <div className='google_review_popup_description'>{ review.description }</div>
            </div>
        </div>
    );
};

export default ReviewPopup;
